import { getRedisClient } from "../../client";

const key = "enginePaths:all";

export async function setEnginePaths(paths: string[], ttlInSec?: number) {
  const client = getRedisClient();
  const stringified = JSON.stringify(paths);

  if (ttlInSec) {
    await client.set(key, stringified, { EX: ttlInSec });
  } else {
    await client.set(key, stringified);
  }
}

export async function getEnginePaths(): Promise<string[] | null> {
  const client = getRedisClient();
  const data = await client.get(key);
  return data ? (JSON.parse(data) as string[]) : null;
}

export async function deleteEnginePaths() {
  const client = getRedisClient();
  await client.del(key);
}